import React, {Component} from 'react'
import { Switch, Route } from 'react-router-dom'
import {Card} from 'reactstrap'
import WeldersList from '../../components/Welders/WeldersList'
import Certificate from '../../components/Welders/Certificate'

export default class Welders extends Component {

  render() {
    return (
      <div className="animated fadeIn">
        <Card>
          <Switch>
            <Route exact path="/welders" component={WeldersList}/>
            <Route exact path="/welders/:id" component={Certificate}/>
          </Switch>
        </Card>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Welders/Welders.js